module.exports = __webpack_public_path__ + "2024523:cc8b0e4ed9b4c71b9cb2/img/Till-This-Day-Tile_no-spot.44aac0a.png";